var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, Defaults, ViewChild, PropertyConverters } from '@pacem/pacem-core';
import { PacemTextualInputElement } from './input';
import { CHAR_COUNTER_CHILD } from './char-counter';
//namespace Pacem.Components.Scaffolding {
let PacemTextAreaElement = class PacemTextAreaElement extends PacemTextualInputElement {
    constructor() {
        super(...arguments);
        this.rows = 5;
        this.cols = 50;
    }
    /** @override */
    get preventKeyboardSubmit() {
        return true;
    }
    toggleReadonlyView(readonly) {
        this._span.hidden = !readonly;
        this._input.hidden = readonly;
    }
    get inputFields() {
        return [this._input];
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'rows'
            || name === 'cols') {
            this.inputField.setAttribute(name, val);
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemTextAreaElement.prototype, "rows", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemTextAreaElement.prototype, "cols", void 0);
__decorate([
    ViewChild('textarea')
], PacemTextAreaElement.prototype, "_input", void 0);
__decorate([
    ViewChild(`span.${PCSS}-readonly`)
], PacemTextAreaElement.prototype, "_span", void 0);
PacemTextAreaElement = __decorate([
    CustomElement({ tagName: P + '-textarea', template: `<textarea class="${PCSS}-input" pacem></textarea>${CHAR_COUNTER_CHILD}<span class="${PCSS}-readonly"><${P}-text text="{{ :host.viewValue }}"></${P}-text></span>`, shadow: Defaults.USE_SHADOW_ROOT })
], PacemTextAreaElement);
export { PacemTextAreaElement };
